module.exports = __webpack_public_path__ + "img/9.c5da269d.jpg";